// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessOrderSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.696 18.595c.22 1.555.781 3.027 1.66 3.407h-9.51c-2.055 0-2.65-1.697-2.794-3.407z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.797 20.45c-.463-.939-.628-2.071-.682-2.755 0 0 0-.691-.747-.691H5.97V3.003s-.048-.499.524-.499c.496 0 .505.499 1.006.499.5 0 .995-1.004 1.5-1.004.504 0 .999.996 1.503 1.004.497-.003.995-1.004 1.5-1.004.497 0 .994 1.004 1.498 1.004.499 0 .999-1.004 1.494-1.004.51 0 1.005 1.004 1.48 1.004.528 0 1.023-1.004 1.523-1.004s1.004 1 1.504 1 .498-.495.998-.495c.554 0 .49.494.49.494v16.17c0 1.781-.998 2.834-3.129 2.834-1.012-.042-1.628-.67-2.064-1.552zM18.83 8.264a.72.72 0 0 0 .225-.525.72.72 0 0 0-.225-.525.72.72 0 0 0-.525-.225.72.72 0 0 0-.525.225.72.72 0 0 0-.225.525c0 .2.075.375.225.525a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225zM7.995 7.98a.5.5 0 0 0 .5.5h6.984a.5.5 0 0 0 .5-.5v-.462a.5.5 0 0 0-.5-.5H8.495a.5.5 0 0 0-.5.5zm7.484 3.484a.5.5 0 0 0 .5-.5v-.461a.5.5 0 0 0-.5-.5H8.495a.5.5 0 0 0-.5.5v.461a.5.5 0 0 0 .5.5zm3.35-.186a.72.72 0 0 0 .225-.525.72.72 0 0 0-.225-.525.72.72 0 0 0-.525-.226.72.72 0 0 0-.525.226.72.72 0 0 0-.225.525c0 .2.075.375.225.525a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225zm-3.345 3.194a.5.5 0 0 0 .5-.5v-.462a.5.5 0 0 0-.5-.5H8.5a.5.5 0 0 0-.5.5v.462a.5.5 0 0 0 .5.5zm2.3-.187a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225.72.72 0 0 0 .225-.525.72.72 0 0 0-.225-.525.72.72 0 0 0-.525-.225.72.72 0 0 0-.525.225.72.72 0 0 0-.225.525c0 .2.075.375.225.525z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessOrderSolid;
